import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.plan.subtipos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Subtipo de Transferencia ha sido creado con éxito."}
                title={"Nuevo Subtipo de Transferencia"}
                buttonTitle={"Nuevo Subtipo de Transferencia"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Tipo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_SubTipos/Create.js